var _title, _path, _polygon, _path2, _path3, _ellipse, _ellipse2, _path4, _path5, _path6, _path7, _path8, _polygon2, _polygon3, _polygon4, _path9, _path10, _path11, _path12, _path13, _circle, _path14, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDigmenthaHead = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216.16,
    height: 300,
    viewBox: "0 0 216.16 300",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ERP_head")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85,32.11,60.26,26s4.63-9.53,7.56-10.12S94.19,3.93,94.19,3.93s30.78.59,33.6,2.38S148,18,148,18V29.53l-20.24,5-8.44,8.74S85.09,40.59,85,38.33,85,32.11,85,32.11Z",
    transform: "translate(0 0)",
    fill: "#c2c2c2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "108.73 299.44 106.86 299.08 104.8 299.08 104.8 299.44 104.8 299.61 108.73 299.61 108.73 299.44",
    fill: "#9b9b9b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.39,38C55.13,38,12.32,75,8.16,122.14a.56.56,0,0,0-.3,0h.3a2.43,2.43,0,0,1-.07.7H7.87V123l7.71,94.64c1.1,13.44,1.66,20.23,10.16,31.55,15.34,20.57,41.55,35.39,63.6,47.12a43.53,43.53,0,0,0,37.83-1.3c4.59-1.54,13.25-7.5,17.14-9.71,5.14-2.92,9.75-7.43,14.56-10.86,10-7.17,6.46-5.93,20-17.46,16.88-14.44,22.32-37.24,23.53-57.32l2.1-34.88c.84-13.88,2.52-28,2.52-41.9v-.77C202.85,75,159.65,38,107.39,38Z",
    transform: "translate(0 0)",
    fill: "#edaa88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17,153.28a18.27,18.27,0,0,0-17,18v30.78a18.27,18.27,0,0,0,17,18V153.28Zm182.1,0a18.27,18.27,0,0,1,17,18v30.78a18.27,18.27,0,0,1-17,18V153.28Z",
    transform: "translate(0 0)",
    fill: "#edaa88"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.79,
    cy: 177.51,
    rx: 5.24,
    ry: 7.21
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.67,
    cy: 177.51,
    rx: 5.24,
    ry: 7.21
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.82,247.84c-.9.29-3.24,1.31-4.38,1.74-1.14-.48-3.49-1.46-4.38-1.74-5.56-1.75-17.9,6.53-17.9,6.53v.5c15.28,1.59,20.55-.33,22.27-2.23,1.72,1.91,7,3.82,22.27,2.23v-.5S117.39,246.08,111.82,247.84Z",
    transform: "translate(0 0)",
    fill: "#ab7661"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.15,253.66s20.24,18.77,44.54,0l-22.26-4.76Z",
    transform: "translate(0 0)",
    fill: "#ab7661"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "36.24 159.82 23.58 192.51 32.12 193.89 47.16 159.82 36.24 159.82",
    fill: "#f2cfbf",
    opacity: 0.49,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.22 159.82 36.68 192.51 40.13 193.89 55.02 159.82 49.22 159.82",
    fill: "#f2cfbf",
    opacity: 0.49,
    style: {
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.64,195.2H28.27A11.22,11.22,0,0,1,17,184V169.7a11.22,11.22,0,0,1,11.24-11.18H89.64a11.22,11.22,0,0,1,11.24,11.18V184A11.22,11.22,0,0,1,89.64,195.2ZM28.27,161a8.73,8.73,0,0,0-8.75,8.71V184a8.73,8.73,0,0,0,8.75,8.71H89.64A8.73,8.73,0,0,0,98.39,184V169.73A8.73,8.73,0,0,0,89.64,161ZM186.58,195.2H125.21A11.22,11.22,0,0,1,114,184V169.7a11.22,11.22,0,0,1,11.24-11.18h61.37a11.22,11.22,0,0,1,11.24,11.18V184a11.22,11.22,0,0,1-11.24,11.16ZM125.21,161a8.73,8.73,0,0,0-8.75,8.71V184a8.73,8.73,0,0,0,8.75,8.71h61.37a8.73,8.73,0,0,0,8.75-8.71V169.73a8.73,8.73,0,0,0-8.75-8.71Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115,184.72a9.83,9.83,0,0,0-13.75,0L99.56,183c.08-.08,8.22-7.86,17,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.35,154.19s23.35-118.65,95.34-88c0,0,69.1-31.53,99.9,88.37l4-31.81S201.13,24,107.55,38.36c0,0-89.28-27.54-99.69,84.53Z",
    transform: "translate(0 0)",
    fill: "#c2c2c2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "85.15 35.37 105.29 37.99 125.76 36.96 105.56 35.37 85.15 35.37",
    fill: "#cf252a"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "197.91 188.65 205.68 154.59 192.58 159.67 197.21 165.66 197.91 188.65",
    fill: "#fff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "18.25 188.65 10.48 154.59 23.58 159.67 18.95 165.66 18.25 188.65",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M201.53,125.76s20.72,85.92,10.48,104.8c0,0,1.17-66.16-15.5-104.8h5Zm-188.21,0S-7.4,211.69,2.84,230.57c0,0-1.17-66.16,15.5-104.8h-5Z",
    transform: "translate(0 0)",
    fill: "#c2c2c2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M129.69,238.43s11.68,13.36,6.56,27.51m-51.1-27.51s-11.68,13.36-6.56,27.51m49.79-69.43a42,42,0,0,0,40.61,0m-120.52,0a42,42,0,0,0,40.61,0",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#b57962",
    strokeWidth: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.42,65.94s22.89-5.27,23.14,24.45C130.52,90.39,136.28,56.2,107.42,65.94Zm21-37.12S138.24,8.33,161.14,26C161.08,26,138.43,1.07,128.38,28.82Z",
    transform: "translate(0 0)",
    fill: "#c2c2c2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M128.38,26.2s9.86-20.49,32.75-2.79C161.08,23.41,138.43-1.55,128.38,26.2ZM86.46,34.06s-9.86-20.49-32.75-2.79C53.71,31.25,76.36,6.32,86.46,34.06Zm7.86,26.66S69.89,66.15,73.9,95.63C73.9,95.63,68.13,55.57,94.32,60.72Zm10.32-38.45S101-.67,129.69,1C129.69,1,97-6.89,104.64,22.27Z",
    transform: "translate(0 0)",
    fill: "#c2c2c2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M167.69,89.81s17.4-8.28,6.51-76.71c0,0,18.07,50.15,3.58,78.6Z",
    transform: "translate(0 0)",
    fill: "#edaa88"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 173.58,
    cy: 12.45,
    r: 5.9,
    fill: "#edaa88"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.54,92.43S27.14,84.15,38,15.72c0,0-18.07,50.15-3.58,78.6Z",
    transform: "translate(0 0)",
    fill: "#edaa88"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.65,
    cy: 15.07,
    r: 5.9,
    fill: "#edaa88"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDigmenthaHead, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/digmentha-head.54b731b8.svg";
export { ForwardRef as ReactComponent };